export const enum PropertySavedStatechartStoreStateEnum {
  loading = 'loading',
  saved = 'saved',
  unsaved = 'unsaved',
  iddle = 'iddle',
}
